import React, { useState } from "react";
import Style from "./AddProductToStore.module.css";
import { useForm } from "react-hook-form";
import { AddProductSuppermarketAPI } from "../../../Api/SupplierServices";
import { errorToast, succToast } from "../../../Utils/Toast/Toast";
const AddProductToStore = ({ productData }) => {
  ///////////////// States /////////////////////
  const [disable, setDisable] = useState(false);

  //////////////// handle form ///////////////////////////
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  ////////////// send form data //////////////////////
  const onSubmit = (data, e) => {
    // setLoading(true);
    setDisable(true);
    let info = null;
    info = {
      price: data.price === "" ? 0 : data.price,
      count: data.count === "" ? 0 : data.count,
      max_count: data.maxCount === "" ? 0 : data.maxCount,
      off_price: data.off ? data.off : 0,
      new: "0",
      product_id:productData.id,
    };
    
    AddProductSuppermarketAPI(info, (res) => {
      if (res.status === 0) {
        // setProductInput("");
        errorToast(res.message);
        setDisable(false);
        e.target.reset();
      } else {
        e.target.reset();
        succToast(res.message);
        // setProductInput("");
        setDisable(false);
      }
    });
  };

  return (
    <div className={Style.componentHolder}>
      <h2 className={Style.titleOfComponent}>افزودن به انبار</h2>
      <hr
        style={{
          height: "3px",
          border: "none",
          color: "#c20c64",
          backgroundColor: "#c20c64",
        }}
      />
      <form onSubmit={handleSubmit(onSubmit)} className={Style.FormAddProduct}>
        <input
          {...register("productName", { required: true })}
          className={errors.productName ? Style.errorInput : Style.fileInputPart2}
          placeholder={"نام محصول"}
          value={productData&&productData.name}
          type="text"
          disable
        />
        <input
          {...register("maxCount", { required: true })}
          className={errors.maxCount ? Style.errorInput : Style.fileInputPart2}
          placeholder={"حداکثر تعداد"}
          type="text"
        />
        <input
          {...register("price", { required: true })}
          className={errors.price ? Style.errorInput : Style.fileInputPart2}
          placeholder={"قیمت به تومان"}
          type="text"
        />
        <input
          {...register("off")}
          className={errors.off ? Style.errorInput : Style.fileInputPart2}
          placeholder={"قیمت با تخفیف به تومان"}
          type="text"
        />
        <input
          {...register("count", { required: true })}
          className={errors.count ? Style.errorInput : Style.fileInputPart2}
          placeholder={"تعداد"}
          type="text"
        />
        <div style={{ display: "flex", justifyContent: "center" }}>
          <button className={Style.btnStyle} type={"submit"} disabled={disable}>
            ثبت
          </button>
        </div>
      </form>
    </div>
  );
};

export default AddProductToStore;
